import type { Backend } from '@freelancer/datastore/core';
import {
  getQueryParamValue,
  OrderByDirection,
} from '@freelancer/datastore/core';
import type { SuperuserGroupsCollection } from './superuser-groups.types';

export function superuserGroupsBackend(): Backend<SuperuserGroupsCollection> {
  return {
    defaultOrder: {
      field: 'orderByFeedReadLatestTimeInMs',
      direction: OrderByDirection.DESC,
    },
    fetch: (authUid, ids, query, order) => ({
      endpoint: 'groups/0.1/groups',
      isGaf: false,
      params: {
        // TODO: T273728 remove is_group_member as it's been replaced by group_member_status
        is_group_member: false,
        group_ids: ids,
        types: getQueryParamValue(query, 'groupType'),
        status: getQueryParamValue(query, 'status'),
        seo_urls: [
          query?.searchQueryParams.seoUrl as string,
          ...getQueryParamValue(query, 'seoUrl'),
        ],
        group_member_status: query?.searchQueryParams.memberStatus,
        offset: query?.searchQueryParams.offset,
        group_name_search: query?.searchQueryParams.name,
      },
    }),
    push: (authUid, document, extra) => {
      return {
        endpoint: 'groups/0.1/groups',
        isGaf: false,
        payload: {
          name: document.name,
          description: document.description,
          creator_id: document.creatorId,
          creator_type: document.creatorType,
          group_type: document.groupType,
          status: document.status,
          pool_ids: document.poolIds,
        },
      };
    },
    set: undefined,
    update: (authUid, group, originalGroup) => {
      return {
        endpoint: `superuser/0.1/groups/${originalGroup.id}/`,
        method: 'PUT',
        payload: {
          name: group.name,
          description: group.description,
          seo_url: group.seoUrl,
          status: group.status,
        },
      };
    },
    remove: (_, groupId, group) => ({
      endpoint: `superuser/0.1/groups/${groupId}/`,
      method: 'DELETE',
      payload: {},
    }),
  };
}
